<template>
    <div class="content">
        <div class="router-view" id="app-router">
            <!-- route start -->
            <router-view v-slot="{ Component }">
                <transition name="slide-fade" mode="out-in">
                    <component :is="Component"/>
                </transition>
            </router-view>
            <!-- // route end -->
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
</template>

<script>
export default {
    name:       'Content'
}
</script>